import { Autocomplete, TextField, Typography } from "@mui/material";
import type { ModelEntry } from "../hooks/use-models.ts";

type Props = {
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  modelName?: string;
  fullWidth?: boolean;
  setModelName: (name: string) => void;
  models: ModelEntry[];
};

export const ModelNameSelect = ({
  modelName,
  setModelName,
  disabled,
  label,
  placeholder,
  fullWidth,
  models,
}: Props) => {
  return (
    <Autocomplete
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
      options={models}
      value={models.find((m) => m.id === modelName) || null}
      onChange={(_, value) => {
        setModelName(value?.id || "");
      }}
      renderOption={(props, option) => (
        <Typography {...props} variant="body2">
          {option.name}
        </Typography>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder || "Select a model..."}
          label={label || "LLM Model"}
          size="small"
        />
      )}
      getOptionLabel={(option) => option.name}
      autoComplete
      includeInputInList
      filterSelectedOptions
      clearOnBlur
      handleHomeEndKeys
    />
  );
};
